<div class="state-indicator {{ stateClass(state()) }}">
    <app-icon
            [svgIcon]="stateToIcon(state())"
            class="state-icon"
    ></app-icon>
</div>
